import { Checkbox, Tooltip } from '@mui/material';
import { Shield, ShieldOff } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';

const SensitiveInfoToggle = () => {
    const [showSensitiveInfo, setShowSensitiveInfo] = useRecoilState(
        showSensitiveInfoState
    );

    return (
        <Tooltip
            title={
                showSensitiveInfo ? (
                    <FormattedMessage id="hidePatientLabelTooltip" />
                ) : (
                    <FormattedMessage id="showPatientInfoTooltip" />
                )
            }
        >
            <Checkbox
                onChange={() => setShowSensitiveInfo(!showSensitiveInfo)}
                checked={!showSensitiveInfo}
                inputProps={{
                    'aria-label': 'Show sensitive info',
                }}
                icon={<ShieldOff size={14} />}
                checkedIcon={<Shield size={14} />}
                size="small"
                sx={{
                    padding: 0.5,
                }}
                data-testid="patient-info-toggle"
            />
        </Tooltip>
    );
};

export default SensitiveInfoToggle;
